import { createFeatureSelector, createSelector } from "@ngrx/store";
import { DigLitSelfAssessmentState } from "./dig-lit-self-assessment.state";
import { StoreConstants } from "src/app/constants/StoreConstants";
import { DigLitSelfAssessmentResult } from "src/app/_models/DigitalLiteracy";
import { HttpErrorResponse } from "@angular/common/http";

export const selectDigLitSelfAssessmentState = createFeatureSelector<DigLitSelfAssessmentState>(
	StoreConstants.STATE_DLSA
);

export const selectDigLitSelfAssessmentDataState = createSelector(
	selectDigLitSelfAssessmentState,
	(state: DigLitSelfAssessmentState): DigLitSelfAssessmentResult => state.data
);

export const selectDigLitSelfAssessmentLoader = createSelector(
  selectDigLitSelfAssessmentState,
  (state: DigLitSelfAssessmentState): boolean => state.loader
);

export const selectSaveDigLitSelfAssessmentResult = createSelector(
  selectDigLitSelfAssessmentState,
  (state: DigLitSelfAssessmentState): boolean => state.saveResult
);

export const selectSaveDigLitSelfAssessmentError = createSelector(
  selectDigLitSelfAssessmentState,
  (state: DigLitSelfAssessmentState): HttpErrorResponse => state.error
);

export const selectDigLitCurrentStep = createSelector(
  selectDigLitSelfAssessmentState,
  (state: DigLitSelfAssessmentState): number => state.currentPage
);